/**
 * profile_nav handles the navigation for the profile
 * This is currently a simple hide/show.
 * Clicking on the active profile item will expand the profile navigation on mobile.
 * No effect on desktop.
 */
SC.profileNav = (function () {
  var api = {};
  var activeIdx = null;
  var activeItem = null;
  var container = null;
  var desktopBP = 1024;
  var listItems = null;
  var logoutButton = null;

  function init() {
    // container stores the ul of the nav.
    container = document.getElementById('profile-nav');

    if (!container) {
      return;
    }

    // the currently active item set in the twig template
    activeItem = document.getElementsByClassName('profile__nav__item--active')[0];
    // all list items in the profile nav
    listItems = document.getElementsByClassName('profile__nav__item');
    // the index of the active item in the ul
    activeIdx = getNodeindex(activeItem);

    // if we're on mobile, move the active item to the top of the list
    if (window.innerWidth < desktopBP) {
      container.insertBefore(activeItem, listItems[0]);
    }

    bindListeners();
  }

  /**
   * bindListeners binds all the event listeners for toggling the nav and handling resize.
   * @returns {void}
   */
  function bindListeners() {
    logoutButton = document.getElementById('profile-logout');

    activeItem.addEventListener('click', toggleNav);
    logoutButton.addEventListener('click', trackMPLogout);
    window.addEventListener('resize', handleResize);
    window.addEventListener('orientationchange', handleResize);
  }

  /**
   * trackMpLogout sends an event to MParticle for the logout action
   * @returns {void}
   */
  function trackMPLogout() {
    SC.analytics.mp.sendEvent('Log Out Successful', 'navigation', {'Location': 'Profile'}, 'Profile');
    SC.analytics.branch.logout();
  }

  /**
   * handleResize check if the window width is less than 1024 and moves the active item
   * to the front of the list.  else it moves it to where it was in the dom on load.
   * @returns {void}
   */
  function handleResize() {
    if (window.innerWidth < desktopBP) {
      container.insertBefore(activeItem, listItems[0]);
    } else {
      container.insertBefore(activeItem, listItems[activeIdx + 1]);
    }
  }

  /**
   * getNodeIndex gets the index of the current node inside its parent container.
   *
   * @param {object} node htmlelement to get the index for
   * @return {number} the zero based index of the node
   */
  function getNodeindex(node) {
    var children = node.parentNode.childNodes;
    var idx = 0;

    for (var i = 0; i < children.length; i++) {
      if (children[i] === node) {
        return idx;
      }

      if (children[i].nodeType === 1) {
        idx++;
      }
    }
    return -1;
  }

  /**
   * toggleNav handles expanding/collapsing the profile nav on mobile.
   * simply toggles the profile__nav__list--expanded class.  does not affect desktop
   *
   * @param {object} e click event that triggered the function
   * @returns {void}
   */
  function toggleNav(e) {
    e.preventDefault();
    if (window.innerWidth >= desktopBP) {
      return;
    }

    container.classList.toggle('profile__nav__list--expanded');
  }

  init();
  return api;
})();
